export function campaignContentRoute(basePath, params, canUpdate) {
  const action = canUpdate ? 'update' : 'view'
  const search = new URLSearchParams(params)
  return `${basePath}/${action}?${search}#content`
}



// WEBPACK FOOTER //
// ./src/modules/email-saved-rows/helpers/campaignContentRoute.js